<igx-grid #gridTipoJornada [primaryKey]="'IdTipoJornada'" [width]="'100%'" [height]="'100%'" [locale]="localGrid"
  [allowFiltering]="true" [filterMode]="'excelStyleFilter'" [rowSelection]="activarBotones ? rowSelectionSingle : rowSelectionMultiple" [selectRowOnClick]="false" [igxGridState]="optionsGridLocal"
  [moving]="true" [sortingOptions]="sortingOptions" (rowSelectionChanging)="handleRowSelection()">
  <igx-grid-toolbar>
    <igx-grid-toolbar-title>
      <app-filtro-general-moderno #filtroGeneral descripcionLabel="{{ 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL' | translate}}" (enterPalabra)="filterInput($event)" (limpiarPalabras)="clearInput()" />
    </igx-grid-toolbar-title>
    <igx-grid-toolbar-actions>
      <app-mas-opciones-grid #masOpcionesG [arrayDatosAVer]="[1, 2, 6]" (opcionSeleccionada)="onSelectionDropDown($event)" />
    </igx-grid-toolbar-actions>
  </igx-grid-toolbar>
  <ng-template igxSortHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortAscendingHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortDescendingHeaderIcon>
    <igx-icon>south</igx-icon>
  </ng-template>
  <ng-template igxExcelStyleHeaderIcon>
    <igx-icon>filter_alt</igx-icon>
  </ng-template>
  <igx-column field="TipoJornada" header="{{ 'GRIDS.TIPOJORNADA.COL_TIPOJORNADA' | translate}}" [dataType]="'number'" width="100px" [sortable]="true" [resizable]="true" />
  <igx-column field="DescripcionTipoJornada" header="{{ 'GRIDS.TIPOJORNADA.COL_DESCRIPCIONTIPOJORNADA' | translate}}" [dataType]="'string'" minWidth="280px" [sortable]="true" [resizable]="true" />
</igx-grid>
